/**
 * Represents NCPDP validation types related to Pharmacy Review for a customer.
 */
export enum NcpdpValidationTypeModel {
	/**
	 * Use the NCPDP from the customer file for validation.
	 */
	UseNcpdpFromCustomerFile = 1,
	/**
	 * Use the NCPDP from the customer setup for validation.
	 */
	UseNcpdpFromCustomerSetup = 2,
	/**
	 * Compare the NCPDP from the customer file and the customer setup for validation.
	 */
	CompareNcpdpFromCustomerFileAndSetup = 3
}
